module.exports = __webpack_public_path__ + "img/Slice2.ed595575.png";